/* Vyrexwear maatadviseur: advies op basis van lengte, gewicht en (optioneel) taille.
   Maten, rekenwaarden en alle teksten komen uit de thema-editor (Productpagina > blok Maathulp)
   en staan als data-attributen op het venster. Zonder die waarden gelden de standaardwaarden hieronder. */
(function () {
  'use strict';
  var DEFAULT_SIZES = ['S', 'M', 'L', 'XL'];
  var DEFAULT_REF = { h: [172, 178, 184, 190], w: [65, 73, 82, 92], waist: [73, 79, 85, 92] };
  var DEFAULT_MSG = {
    def: 'Maat [maat] geeft jou de atletische pasvorm waar de short voor ontworpen is: niet te strak, niet te ruim, met een tailleband die stevig zit zonder in te snijden.',
    waist: 'Vul je tailleomtrek in voor een nog nauwkeuriger advies.',
    between: 'Je zit precies tussen [maat1] en [maat2]. Op basis van je voorkeur adviseren we [maat]. Kies [maat1] voor een strakkere, [maat2] voor een ruimere pasvorm.',
    smallest: 'De [maat] is onze kleinste maat. Bij jouw maten valt hij waarschijnlijk iets ruimer; het trekkoord helpt je hem precies goed te laten zitten.',
    largest: 'De [maat] is onze grootste maat. Bij jouw maten kan hij wat strakker zitten. Twijfel je? Stuur ons gerust een bericht, we denken met je mee.',
    saved: 'Jouw maatadvies: [maat]',
    errH: 'Vul een lengte in tussen 140 en 220 cm.',
    errW: 'Vul een gewicht in tussen 40 en 160 kg.',
    errWaist: 'Vul een tailleomtrek in tussen 55 en 130 cm, of laat dit veld leeg.'
  };
  var STORE = 'vx-size-advice';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  /* Tekst met [maat], [maat1], [maat2]: veilig als HTML, met de maten vetgedrukt */
  function fill(tpl, map) {
    var out = esc(tpl);
    Object.keys(map).forEach(function (k) {
      out = out.split('[' + k + ']').join('<strong>' + esc(map[k]) + '</strong>');
    });
    return out;
  }
  function attr(el, name, fallback) {
    var v = el ? el.getAttribute(name) : null;
    return v == null || v === '' ? fallback : v;
  }
  function list(str) {
    return String(str || '').split(',').map(function (x) { return x.trim(); }).filter(function (x) { return x !== ''; });
  }
  function numbers(str) {
    return list(str).map(function (x) { return parseFloat(x); }).filter(function (x) { return isFinite(x); });
  }
  /* Rekenwaarden per maat: moeten er precies evenveel zijn als maten, anders de standaard (of een gelijkmatige verdeling) */
  function refFor(str, def, n) {
    var arr = numbers(str);
    if (arr.length === n && n >= 2) return arr;
    if (def.length === n) return def;
    var out = [], lo = def[0], hi = def[def.length - 1];
    for (var i = 0; i < n; i++) out.push(n === 1 ? lo : lo + (hi - lo) * i / (n - 1));
    return out;
  }
  function config(dlg) {
    var sizes = list(attr(dlg, 'data-sizes', ''));
    if (sizes.length < 2) sizes = DEFAULT_SIZES.slice();
    var n = sizes.length;
    return {
      sizes: sizes,
      ref: {
        h: refFor(attr(dlg, 'data-ref-h', ''), DEFAULT_REF.h, n),
        w: refFor(attr(dlg, 'data-ref-w', ''), DEFAULT_REF.w, n),
        waist: refFor(attr(dlg, 'data-ref-waist', ''), DEFAULT_REF.waist, n)
      },
      msg: {
        def: attr(dlg, 'data-msg-default', DEFAULT_MSG.def),
        waist: dlg && dlg.hasAttribute('data-msg-waist') ? dlg.getAttribute('data-msg-waist') : DEFAULT_MSG.waist,
        between: attr(dlg, 'data-msg-between', DEFAULT_MSG.between),
        smallest: attr(dlg, 'data-msg-smallest', DEFAULT_MSG.smallest),
        largest: attr(dlg, 'data-msg-largest', DEFAULT_MSG.largest),
        saved: attr(dlg, 'data-msg-saved', DEFAULT_MSG.saved),
        errH: attr(dlg, 'data-err-h', DEFAULT_MSG.errH),
        errW: attr(dlg, 'data-err-w', DEFAULT_MSG.errW),
        errWaist: attr(dlg, 'data-err-waist', DEFAULT_MSG.errWaist)
      }
    };
  }

  /* Zet een waarde om naar een doorlopende maat-index (0 = kleinste maat), met doortrekken buiten het bereik. */
  function idx(v, arr) {
    if (v <= arr[0]) return (v - arr[0]) / (arr[1] - arr[0] || 1);
    for (var i = 0; i < arr.length - 1; i++) {
      if (v <= arr[i + 1]) return i + (v - arr[i]) / (arr[i + 1] - arr[i] || 1);
    }
    var n = arr.length - 1;
    return n + (v - arr[n]) / (arr[n] - arr[n - 1] || 1);
  }

  function advise(cfg, h, w, waist, fit) {
    var R = cfg.ref, S = cfg.sizes, last = S.length - 1;
    var t = waist ? 0.6 * idx(waist, R.waist) + 0.28 * idx(w, R.w) + 0.12 * idx(h, R.h)
                  : 0.68 * idx(w, R.w) + 0.32 * idx(h, R.h);
    var lo = Math.floor(t), frac = t - lo, pick;
    var between = frac > 0.38 && frac < 0.62 && lo >= 0 && lo < last;
    if (between) pick = fit < 0 ? lo : fit > 0 ? lo + 1 : Math.round(t);
    else pick = Math.round(t + fit * 0.3);
    pick = Math.max(0, Math.min(last, pick));
    return { t: t, last: last, size: S[pick], between: between ? [S[lo], S[lo + 1]] : null, waist: !!waist };
  }

  function message(cfg, r) {
    var M = cfg.msg;
    if (r.t > r.last + 0.7) return fill(M.largest, { maat: r.size });
    if (r.t < -0.7) return fill(M.smallest, { maat: r.size });
    if (r.between) return fill(M.between, { maat: r.size, maat1: r.between[0], maat2: r.between[1] });
    return fill(M.def, { maat: r.size }) + (r.waist || !M.waist ? '' : ' ' + esc(M.waist));
  }

  function save(size) { try { localStorage.setItem(STORE, size); } catch (e) {} }
  function load() { try { return localStorage.getItem(STORE); } catch (e) { return null; } }

  function showSaved(size, cfg) {
    if (!size) return;
    if (cfg.sizes.indexOf(size) === -1) return;
    var text = cfg.msg.saved.indexOf('[maat]') > -1 ? cfg.msg.saved.split('[maat]').join(size) : cfg.msg.saved + ' ' + size;
    document.querySelectorAll('[data-sg-saved]').forEach(function (el) {
      el.textContent = text;
    });
  }

  function pickSize(size) {
    var inputs = document.querySelectorAll('[data-product] [data-option-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === size) {
        if (!inputs[i].checked) inputs[i].click();
        return true;
      }
    }
    return false;
  }

  function initDialog(dlg) {
    var cfg = config(dlg);
    var tabs = dlg.querySelectorAll('[role="tab"]');
    var scroller = dlg.querySelector('[data-sg-scroll]');
    var locked = false;
    var panels = dlg.querySelectorAll('[data-sg-panel]');

    function selectTab(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-sg-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-sg-panel') !== name; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-sg-tab')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        selectTab(n.getAttribute('data-sg-tab'), true);
      });
    });

    /* Openen vanaf elke trigger (en via een link met #maatadvies of #maattabel) */
    function openWith(tab) {
      selectTab(tab || 'advies');
      if (dlg.open) return;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      if (scroller) scroller.scrollTop = 0;
      if (window.vxScrollLock) { window.vxScrollLock.lock(); locked = true; }
    }
    dlg.vxOpen = openWith;
    document.querySelectorAll('[data-sg-open="' + dlg.id + '"]').forEach(function (b) {
      b.addEventListener('click', function () { openWith(b.getAttribute('data-sg-tab')); });
    });
    /* Pagina weer vrijgeven bij sluiten (knop, Esc of klik buiten het venster) */
    dlg.addEventListener('close', function () {
      if (locked && window.vxScrollLock) window.vxScrollLock.unlock();
      locked = false;
    });

    /* cm / inch */
    var unitBtns = dlg.querySelectorAll('[data-sg-unit]');
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-sg-unit');
        unitBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        dlg.querySelectorAll('[data-sg-unit-label]').forEach(function (l) { l.textContent = u === 'in' ? 'inch' : 'cm'; });
        dlg.querySelectorAll('[data-cm]').forEach(function (el) {
          var cm = parseFloat(el.getAttribute('data-cm'));
          if (!isFinite(cm)) return;
          var v = u === 'in' ? (cm / 2.54).toFixed(1) : String(cm);
          el.textContent = v.replace('.', ',').replace(/,0$/, '');
        });
      });
    });

    /* Advies */
    var form = dlg.querySelector('[data-sg-form]');
    var result = dlg.querySelector('[data-sg-result]');
    var err = dlg.querySelector('[data-sg-error]');
    var current = null;
    if (!form || !result || !err) return;

    function highlight(size) {
      var col = cfg.sizes.indexOf(size) + 2;
      dlg.querySelectorAll('.vx-sg__table tr > *').forEach(function (c) { c.classList.remove('is-match'); });
      if (col < 2) return;
      dlg.querySelectorAll('.vx-sg__table tr > *:nth-child(' + col + ')').forEach(function (c) { c.classList.add('is-match'); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var h = parseFloat(form.h.value), w = parseFloat(form.w.value), waist = parseFloat(form.waist.value);
      var fitEl = form.querySelector('input[name="fit"]:checked');
      var fit = fitEl ? parseInt(fitEl.value, 10) : 0;
      var msg = '';
      if (!(h >= 140 && h <= 220)) msg = cfg.msg.errH;
      else if (!(w >= 40 && w <= 160)) msg = cfg.msg.errW;
      else if (form.waist.value !== '' && !(waist >= 55 && waist <= 130)) msg = cfg.msg.errWaist;
      err.hidden = !msg;
      err.textContent = msg;
      if (msg) { result.hidden = true; return; }
      var r = advise(cfg, h, w, form.waist.value === '' ? 0 : waist, fit);
      current = r.size;
      dlg.querySelectorAll('[data-sg-size]').forEach(function (el) { el.textContent = r.size; });
      var textEl = dlg.querySelector('[data-sg-text]');
      if (textEl) textEl.innerHTML = message(cfg, r);
      result.hidden = false;
      highlight(r.size);
      save(r.size);
      showSaved(r.size, cfg);
      if (result.scrollIntoView) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var pickBtn = dlg.querySelector('[data-sg-pick]');
    if (pickBtn) pickBtn.addEventListener('click', function () {
      if (current) pickSize(current);
      dlg.close();
    });
    var resetBtn = dlg.querySelector('[data-sg-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () {
      result.hidden = true;
      form.reset();
      highlight('');
      form.h.focus();
    });
  }

  /* Direct openen via een link, bijv. vanuit het zoekvenster: /products/...#maatadvies of #maattabel */
  var HASH_TABS = { '#maatadvies': 'advies', '#maattabel': 'tabel' };
  function fromHash(tries) {
    var tab = HASH_TABS[window.location.hash];
    if (!tab) return;
    if (!window.vxScrollLock && (tries || 0) < 20) { setTimeout(function () { fromHash((tries || 0) + 1); }, 50); return; }
    var dlg = document.querySelector('[data-sg]');
    if (!dlg || typeof dlg.vxOpen !== 'function') return;
    if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname + window.location.search);
    dlg.vxOpen(tab);
  }

  function init() {
    var dialogs = document.querySelectorAll('[data-sg]');
    dialogs.forEach(initDialog);
    if (dialogs.length) showSaved(load(), config(dialogs[0]));
    fromHash(0);
    window.addEventListener('hashchange', function () { fromHash(0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
